



export const hasDataTableData = (rows) => rows.length > 0;